import { render, staticRenderFns } from "./user_pas.vue?vue&type=template&id=a053fc36&scoped=true&"
import script from "./user_pas.vue?vue&type=script&lang=js&"
export * from "./user_pas.vue?vue&type=script&lang=js&"
import style0 from "./user_pas.vue?vue&type=style&index=0&id=a053fc36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a053fc36",
  null
  
)

export default component.exports